define('shared/util/checkout/offer',[
    'shared/lib/RSVP', 
    'shared/util/state'
], 
function (
    RSVP,
    state
) {
    return {
        updateStateByOffer: function ( offer ){
            var promises = [];

            if ( offer.Name != null && offer.Name != false ) {
                promises.push(state.push( 'order.offer_name', offer.Name ));
            }

            if ( offer.MarketCode != null && offer.MarketCode != false ) {
                promises.push(state.push( 'order.offer_market', offer.MarketCode ));
            }

            if ( offer.Phases && offer.Phases.length > 0 ) {
                if(typeof(offer.Phases.sort) === 'function'){
                    offer.Phases.sort(function(a, b){
                        return a.PhaseNumber - b.PhaseNumber;
                    });
                }

                var offerMaxPhases = 3;
                for(var i = 0 ; i < offerMaxPhases; i++) {
                    var offerPhase = offer.Phases[i];
                    var phaseInState;
                    if(offerPhase){
                        phaseInState = {
                            price: offerPhase.Price,
                            currency: offer.CurrencyCode,
                            is_recurring: offerPhase.IsRecurring,
                            phase_duration: offerPhase.PhaseDuration,
                            phase_duration_unit: offerPhase.PhaseDurationUnit,
                            repeat_times: offerPhase.RepeatTimes
                        };
                    }
                    else{
                        phaseInState = null;
                    }

                    promises.push(state.push( 'order.phase' + i, phaseInState ));
                }
            }

            return RSVP.all(promises);
        }
    };
});


